import { useState, useCallback } from 'react';

/**
 * Hook for managing panel visibility and active states
 * @returns {Object} Panel state and handlers
 */
export function usePanelState() {
  // Sidebar and panel states
  const [activeSidebarView, setActiveSidebarView] = useState('browser');
  const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
  const [isRightPanelCollapsed, setIsRightPanelCollapsed] = useState(true); // Default to collapsed
  const [bottomPanelOpen, setBottomPanelOpen] = useState(false);
  const [bottomPanelHeight, setBottomPanelHeight] = useState(400); // Default height ~50% of typical viewport
  
  // Apply sidebar change (basic logic)
  const applySidebarChange = useCallback((buttonId) => {
    if (activeSidebarView === buttonId && !isLeftPanelCollapsed) {
      setIsLeftPanelCollapsed(true);
    } else {
      setActiveSidebarView(buttonId);
      if (isLeftPanelCollapsed) {
        setIsLeftPanelCollapsed(false);
      }
    }
  }, [activeSidebarView, isLeftPanelCollapsed]);
  
  // Toggle panels
  const toggleLeftPanel = useCallback(() => {
    setIsLeftPanelCollapsed(prev => !prev);
  }, []);
  
  const toggleRightPanel = useCallback(() => {
    setIsRightPanelCollapsed(prev => !prev);
  }, []);
  
  const toggleBottomPanel = useCallback(() => {
    setBottomPanelOpen(prev => !prev);
  }, []);
  
  // Open specific panels
  const openBottomPanel = useCallback(() => {
    setBottomPanelOpen(true);
  }, []);
  
  const closeBottomPanel = useCallback(() => {
    setBottomPanelOpen(false);
  }, []);
  
  const openRightPanel = useCallback(() => {
    setIsRightPanelCollapsed(false);
  }, []);
  
  return {
    // States
    activeSidebarView,
    setActiveSidebarView,
    isLeftPanelCollapsed,
    setIsLeftPanelCollapsed,
    isRightPanelCollapsed,
    setIsRightPanelCollapsed,
    bottomPanelOpen,
    setBottomPanelOpen,
    bottomPanelHeight,
    setBottomPanelHeight,
    
    // Handlers
    applySidebarChange,
    toggleLeftPanel,
    toggleRightPanel,
    toggleBottomPanel,
    openBottomPanel,
    closeBottomPanel,
    openRightPanel
  };
}